// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__5kNHr","notes":"Notes_notes__shhiR","note":"Notes_note__gDYa6","markdown":"Notes_markdown__hPAn3"};